export default __webpack_public_path__ + "static/media/14233826931544610471.720abcc8.svg";